<template>
  <div>
    <div class="fixed width-100 z-99">
      <van-tabs v-model="tabIndex" @change="tabsChange">
        <van-tab title="我的待办"></van-tab>
        <van-tab title="我的已办"></van-tab>
        <van-tab title="我的发起"></van-tab>
        <van-tab title="抄送我的"></van-tab>
      </van-tabs>
      <!--  固定位搜索栏  -->
      <van-search class="fixed width-100 z-99" clearable shape="round" v-model="queryParams.startUserName" show-action
                  @search="onSearch">
        <template #action>
          <div class="w-110 h-52 l-h-52 bg-FFDA3E b-r-28 text-center" @click="onSearch">搜索</div>
        </template>
      </van-search>


    </div>
    <!--   占位   -->
    <div class="h-210"></div>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list :immediate-check="false" v-model="loading" :error.sync="error" :finished="finished"
                finished-text="没有更多了" @load="getList"
                class="p-l-20 p-r-20 p-b-20">
        <div @click="change(item)" v-for="(item,index) in list" :key="index" class="bg-FF p-20 m-t-20">
          <div class="flex col-center row-between">
            <img class="w-52 h-52"
                 :src="`${image_base_url}/${icons.find(icon => icon.groupId === item.groupId)? icons.find(icon => icon.groupId === item.groupId).icon : 'zhengxuanlist_icon.png'}`"></img>
            <!-- 标题 -->
            <div class="flex-1 font-30 cor-3E3A39 font-weight-600 m-l-10">
              {{ item.title }}
            </div>
            <div class="font-26 cor-B3 white-spc-nowrap">
              {{ item.taskCreatedTime ? moment(item.taskCreatedTime).format('YYYY-MM-DD HH:mm') : '' }}
            </div>
          </div>

          <van-row type="flex" align="center" class="m-t-20">
            <van-col span="6">
              <div class="cor-88 font-30">部门</div>
            </van-col>
            <van-col span="18">
              <div class="cor-33 font-30">
                {{ item?.startUser?.deptName }}
              </div>
            </van-col>
          </van-row>

          <van-row type="flex" align="center" class="m-t-20">
            <van-col span="6">
              <div class="cor-88 font-30">流程状态</div>
            </van-col>
            <van-col span="18">
              <div class="cor-33 font-30">
                {{ item.businessStatusName }}
              </div>
            </van-col>
          </van-row>

          <van-row v-if="item.currentUserName" type="flex" align="center" class="m-t-20">
            <van-col span="6">
              <div class="cor-88 font-30">当前处理人</div>
            </van-col>
            <van-col span="18">
              <div class="cor-33 font-30">
                {{ item.currentUserName }}
              </div>
            </van-col>
          </van-row>
          <van-row v-if="item.currentUserName" type="flex" align="center" class="m-t-20">
            <van-col span="6">
              <div class="cor-88 font-30">事由</div>
            </van-col>
            <van-col span="18">
              <div class="cor-33 font-30">
                {{ item.sy }}
              </div>
            </van-col>
          </van-row>
          <van-row type="flex" align="center" class="m-t-20">
            <van-col span="6">
              <div class="cor-88 font-30">摘要</div>
            </van-col>
            <van-col span="18">
              <div class="cor-33 font-30" style="word-break: break-all;white-space: pre-line;">
                {{ item.summary }}
              </div>
            </van-col>
          </van-row>
        </div>
      </van-list>
    </van-pull-refresh>


  </div>
</template>
<script>
import moment from "moment/moment";
import {backlogList, havedoneList, receiveList, sponsorList} from "@/api/flow";
import flow from '@/mixin/flow'

export default {
  mixins: [flow],
  data() {
    return {
      moment,
      icons: [
        {groupId: '5', icon: 'bx.png', title: '报销'},
        {groupId: '4', icon: 'dingcan.png', title: '订餐'},
        {groupId: '17', icon: 'fukuan.png', title: '付款'},
        {groupId: '7', icon: 'kaipiao.png', title: '开票'},
        {groupId: '6', icon: 'caiGou.jpg', title: '采购'},
        {groupId: '8', icon: 'qingjia.png', title: '请假'},
        {groupId: '9', icon: 'dingcan.png', title: '用印'},
        {groupId: '11', icon: 'chuchai.png', title: '出差'},
      ],
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      error: false,
      tabIndex: 0,
      queryParams: {
        pageNum: 1,
        pageSize: 20,
        title: "",
        startUserName: ''
      }
    }
  },
  created() {
    this.tabIndex = this.$route.query.tabIndex * 1 || 0;
    this.getList()
  },
  methods: {
    cutOut(str) {
      // 将str中 \n替换为 <br>
      return str.replace(/\n/g, '<br>')
    },
    tabsChange() {
      this.list = []
      this.queryParams.pageNum = 1
      this.queryParams.startUserName = ''
      this.getList()
    },
    change(item) {
      console.log(item.groupId)
      console.log(this.$router.options.routes)
      const current = this.$router.options.routes.find(rourer => {
        return rourer?.meta?.groupId == item.groupId
      })
      console.log(current)
      // if (item.groupId != 5 && item.groupId != 4 && item.groupId != 8 && item.groupId != 9 && item.groupId != 11 &&
      //     item.groupId != 21 && item.groupId != 20 && item.groupId != 22 && item.groupId != 24 && item.groupId != 23 && item.groupId != 17
      // ) {
      //   return this.$toast('该流程正在测试中，敬请期待。。。')
      // }
      this.$router.push({
        path: current.path,
        query: {
          processInstanceId: item.processInstanceId,
          taskId: item.taskId,
          lastPage: '/myWork',
          groupId: current.meta.groupId,
          lastPageTabIndex: this.tabIndex,
          templateId: item.formId ? item.formId : item.templateId,
        }
      })
    },
    // 下拉
    onRefresh() {
      this.finished = false;
      this.list = []
      this.queryParams.pageNum = 1
      this.getList();
    },

    onSearch() {
      this.finished = false
      this.queryParams.pageNum = 1;
      this.list = []
      this.getList();
    },
    async getList() {
      try {
        this.loading = true;
        this.finished = false;
        let list = []
        let totals = 0
        if (this.tabIndex === 0) { // 我的待办
          const {rows, total} = await backlogList(this.queryParams)
          list = rows
          totals = total
        } else if (this.tabIndex === 1) { // 我的已办
          const {rows, total} = await havedoneList(this.queryParams)
          list = rows
          totals = total
        } else if (this.tabIndex === 2) {// 我的发起
          const {rows, total} = await sponsorList(this.queryParams)
          list = rows
          totals = total
        } else if (this.tabIndex === 3) {// 抄送我的
          const {rows, total} = await receiveList(this.queryParams)
          list = rows
          totals = total
        }
        if (list.length === 0) {
          this.finished = true;
        }
        if (totals == list.length) {
          this.finished = true
        }
        this.list = this.list.concat(list)

        this.queryParams.pageNum++;
        this.loading = false;
        this.refreshing = false;
      } catch (e) {
        this.error = true
      }
    }
  }
}
</script>
